import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { SignupForm } from '../components/auth/AuthForm';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import {
  PageWrapper,
  FormContainer,
  LogoContainer,
  Logo,
  BrandName,
  Title,
  CloseButton,
  SwitchText,
  SwitchLink
} from '../components/auth/AuthStyles';

const SignupPage = () => {
  const history = useHistory();
  const { isAuthenticated } = useContext(AuthContext);
  const { language } = useLanguage();
  const t = translations[language].auth;

  useEffect(() => {
    if (isAuthenticated) {
      history.replace('/');
    }
  }, [isAuthenticated, history]);

  const handleSignupSuccess = () => {
    history.replace('/');
  };

  const handleClose = () => {
    history.push('/');
  };

  return (
    <PageWrapper>
      <FormContainer>
        <CloseButton onClick={handleClose} title={t.close}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        
        <LogoContainer>
          <Logo src="/images/QQ-Icon.svg" alt="Quisqueya Quest" />
          <BrandName>Quisqueya Quest</BrandName>
        </LogoContainer>
        
        <Title>{t.createAccount}</Title>
        <SignupForm onSubmit={handleSignupSuccess} />
        <SwitchText>
          {t.haveAccount.split('?')[0]}?{' '}
          <SwitchLink onClick={() => history.push('/login')}>
            {t.signIn}
          </SwitchLink>
        </SwitchText>
      </FormContainer>
    </PageWrapper>
  );
};

export default SignupPage; 